import styled from "styled-components";

export const PortfolioWrapper = styled.section.attrs({
  id: "portfolio",
})``;

export const ProductTitle = styled.div`
  font-weight: 900;
  text-align: center;
  padding-bottom:20px;
  color:black;
  font-size: 1.5rem;

`;
export const FirstText = styled.h5`
  font-weight: 800;
  color:black;
  font-size: 1.5rem;

`;

export const SecondText = styled.h2``;

export const PortfolioContainer = styled.div.attrs({
  className: "container",
})`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 2.5rem;

  @media screen and (max-width: 1024px) {
    grid-template-columns: 1fr 1fr;
    gap: 1.2rem;
  }
  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
    gap: 1rem;
  }
`;

export const PortfolioItem = styled.article`
  background: var(--color-bg-variant);
  padding: 1.2rem;
  border-radius: 2rem;
  border: 1px solid transparent;
  transition: var(--transition);
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  :hover {
    border-color: var(--color-primary-variant);
    background: tranparent;
  }
`;

export const PortfolioItemCta = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const PortfolioItemImageContainer = styled.div`
  border: 0.3rem solid var(--color-primary-variant);
  border-radius: 1.3rem;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  background: #f7f7f7;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PortfolioItemImage = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 1.3rem;
  object-fit: cover;
`;

export const PortfolioTitle = styled.div`
  font-weight: 700;
  display:flex;
  
  padding-bottom:10px;
  color:black;
  font-size: 1rem;
  margin: 1.2rem 0 2rem;
  align-items: center;
`;

export const Price = styled.div`
  width:30%; 
  text-align: right;
  font-size: 1rem;
  
  color:red;
`;

export const Title = styled.div`
  width:70%; 
`;

export const PortfolioItemLink = styled.a.attrs({
  className: "btn",
})``;

export const PortfolioItemLinkTwo = styled.a.attrs({
  className: "btn btn-primary",
})``;
